export const CREATE_PRODUCT = `
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      uuid
      name
      status
      apis { uuid name status }
      categories { uuid name status }
      documents { uuid name status }
      links { uuid name status }
      faqs { uuid name status }
    }
  }
`;

export const UPDATE_PRODUCT = `
  mutation UpdateProduct($uuid: ID!, $input: UpdateProductInput!) {
    updateProduct(uuid: $uuid, input: $input) {
      uuid
      name
      description
      status
      approvalNeeded
      productOwners
      apis { uuid name status }
      categories { uuid name status }
      documents { uuid name status }
      faqs { uuid name status }
      links { uuid name status }
    }
  }
`;

export const CREATE_API = `
  mutation CreateAPI($input: CreateAPIInput!) {
    createAPI(input: $input) {
      uuid
      name
      description
      status
      version
      specContent
      tags
      architectReview
      documents { uuid name status }
    }
  }
`;

export const UPDATE_API = `
  mutation UpdateAPI($uuid: ID!, $input: UpdateAPIInput!) {
    updateAPI(uuid: $uuid, input: $input) {
      uuid
      name
      description
      version
      status
      specContent
      tags
      architectReview
      documents { uuid name status }
    }
  }
`;

export const CREATE_FAQ = `
  mutation CreateFAQ($input: CreateFAQInput!) {
    createFAQ(input: $input) {
      uuid
      tenantId
      name
      description
      status
    }
  }
`;

export const UPDATE_FAQ = `
  mutation UpdateFAQ($uuid: ID!, $input: UpdateFAQInput!) {
    updateFAQ(uuid: $uuid, input: $input) {
      uuid
      tenantId
      name
      status
      description
      question
      answer
    }
  }
`;

export const CREATE_DEVELOPER_GUIDE = `
  mutation CreateDeveloperGuide($input: CreateDeveloperGuideInput!) {
    createDeveloperGuide(input: $input) {
      uuid
      tenantId
      name
      description
      status
      sections {
        id
        sortOrder
        title
        instructions
        codeSamples { id language label code }
      }
      apis { uuid name status }
      products { uuid name status }
    }
  }
`;

export const UPDATE_DEVELOPER_GUIDE = `
  mutation UpdateDeveloperGuide($uuid: ID!, $input: UpdateDeveloperGuideInput!) {
    updateDeveloperGuide(uuid: $uuid, input: $input) {
      uuid
      tenantId
      name
      description
      status
      sections {
        id
        sortOrder
        title
        instructions
        codeSamples { id language label code }
      }
      apis { uuid name status }
      products { uuid name status }
    }
  }
`;

export const DELETE_DEVELOPER_GUIDE = `
  mutation DeleteDeveloperGuide($uuid: ID!) {
    deleteDeveloperGuide(uuid: $uuid)
  }
`;

export const CREATE_LINK = `
  mutation CreateLink($input: CreateLinkInput!) {
    createLink(input: $input) {
      uuid
      tenantId
      name
      description
      entityClass
      status
    }
  }
`;

export const UPDATE_LINK = `
  mutation UpdateLink($uuid: ID!, $input: UpdateLinkInput!) {
    updateLink(uuid: $uuid, input: $input) {
      uuid
      name
      description
      entityClass
      status
    }
  }
`;

export const CREATE_DOCUMENT = `
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      uuid
      tenantId
      name
      status
      description
      tags
      entityClass
      classifications
      content
      sourceFormat
      sourceFileName
      expirationDate
      ragIndexStatus
      parents {
        entityType
        entityId
        name
      }
    }
  }
`;

export const UPDATE_DOCUMENT = `
  mutation UpdateDocument($uuid: ID!, $input: UpdateDocumentInput!) {
    updateDocument(uuid: $uuid, input: $input) {
      uuid
      name
      status
      description
      tags
      entityClass
      classifications
      content
      sourceFormat
      sourceFileName
      expirationDate
      ragIndexStatus
      parents {
        entityType
        entityId
        name
      }
    }
  }
`;

export const RETRY_DOCUMENT_RAG = `
  mutation RetryDocumentRag($uuid: ID!) {
    retryDocumentRag(uuid: $uuid) {
      uuid
      name
      status
      description
      tags
      entityClass
      classifications
      content
      sourceFormat
      sourceFileName
      expirationDate
      ragIndexStatus
      parents {
        entityType
        entityId
        name
      }
    }
  }
`;

export const SEED_ARCHITECTURE_STANDARDS = `
  mutation SeedArchitectureStandards {
    seedArchitectureStandards {
      created
      skipped
      total
    }
  }
`;

export const CREATE_CATEGORY = `
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      uuid
      name
      tenantId
      type
      status
    }
  }
`;

export const UPDATE_CATEGORY = `
  mutation UpdateCategory($uuid: ID!, $input: UpdateCategoryInput!) {
    updateCategory(uuid: $uuid, input: $input) {
      uuid
      name
      status
    }
  }
`;

export const DELETE_API = `
  mutation DeleteAPI($uuid: ID!) {
    deleteAPI(uuid: $uuid)
  }
`;

export const DELETE_FAQ = `
  mutation DeleteFAQ($uuid: ID!) {
    deleteFAQ(uuid: $uuid)
  }
`;

export const DELETE_LINK = `
  mutation DeleteLink($uuid: ID!) {
    deleteLink(uuid: $uuid)
  }
`;

export const DELETE_DOCUMENT = `
  mutation DeleteDocument($uuid: ID!) {
    deleteDocument(uuid: $uuid)
  }
`;

export const DELETE_CATEGORY = `
  mutation DeleteCategory($uuid: ID!) {
    deleteCategory(uuid: $uuid)
  }
`;

export const DELETE_PRODUCT = `
  mutation DeleteProduct($uuid: ID!) {
    deleteProduct(uuid: $uuid)
  }
`;

export const CREATE_SUBSCRIPTION = `
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      uuid
      name
      description
      status
      products {
        productStatus
        product { uuid name }
      }
    }
  }
`;

export const APPROVE_SUBSCRIPTION_PRODUCT = `
  mutation ApproveSubscriptionProduct($subscriptionUuid: ID!, $productUuid: ID!) {
    approveSubscriptionProduct(subscriptionUuid: $subscriptionUuid, productUuid: $productUuid) {
      uuid
      name
      status
      products {
        productStatus
        product { uuid name }
      }
    }
  }
`;

export const REVOKE_SUBSCRIPTION_PRODUCT = `
  mutation RevokeSubscriptionProduct($subscriptionUuid: ID!, $productUuid: ID!) {
    revokeSubscriptionProduct(subscriptionUuid: $subscriptionUuid, productUuid: $productUuid) {
      uuid
      name
      status
      products {
        productStatus
        product { uuid name }
      }
    }
  }
`;

export const APPROVE_SUBSCRIPTION = `
  mutation ApproveSubscription($uuid: ID!) {
    approveSubscription(uuid: $uuid) {
      uuid
      name
      status
      products {
        productStatus
        product { uuid name }
      }
    }
  }
`;

export const REVOKE_SUBSCRIPTION = `
  mutation RevokeSubscription($uuid: ID!) {
    revokeSubscription(uuid: $uuid) {
      uuid
      name
      status
      products {
        productStatus
        product { uuid name }
      }
    }
  }
`;

export const CREATE_APP_KYC = `
  mutation CreateAppKyc($input: CreateAppKycInput!) {
    createAppKyc(input: $input) {
      uuid
      tenantId
      name
      status
      description
      appKeyId
      providerGatewayType
      providerGatewayIdentifier
      appKeyStatus
      keyCreatedOn
      keyExpiresOn
      contactName
      contactEmail
      contactPhone
      contactCompanyName
      contactCompanyWebsite
      bmContactName
      bmContactEmail
      itSupportName
      itSupportEmail
    }
  }
`;

export const UPDATE_APP_KYC = `
  mutation UpdateAppKyc($uuid: ID!, $input: UpdateAppKycInput!) {
    updateAppKyc(uuid: $uuid, input: $input) {
      uuid
      tenantId
      name
      status
      description
      appKeyId
      providerGatewayType
      providerGatewayIdentifier
      appKeyStatus
      keyCreatedOn
      keyExpiresOn
      contactName
      contactEmail
      contactPhone
      contactCompanyName
      contactCompanyWebsite
      bmContactName
      bmContactEmail
      itSupportName
      itSupportEmail
    }
  }
`;

export const DELETE_APP_KYC = `
  mutation DeleteAppKyc($uuid: ID!) {
    deleteAppKyc(uuid: $uuid)
  }
`;

export const DEV_CLEANUP_APP_KYCS = `
  mutation DevCleanupAppKycs {
    devCleanupAppKycs
  }
`;

const GATEWAY_SKU_FIELDS = `
  uuid
  tenantId
  name
  status
  description
  gatewayProductIdentifier
  gatewayProductName
  gatewayCommonName
  gatewayId
  gatewayType
  envName
  skuStatus
  syncedOn
  updatedOn
`;

export const CREATE_GATEWAY_SKU = `
  mutation CreateGatewaySku($input: CreateGatewaySkuInput!) {
    createGatewaySku(input: $input) {
      ${GATEWAY_SKU_FIELDS}
    }
  }
`;

export const UPDATE_GATEWAY_SKU = `
  mutation UpdateGatewaySku($uuid: ID!, $input: UpdateGatewaySkuInput!) {
    updateGatewaySku(uuid: $uuid, input: $input) {
      ${GATEWAY_SKU_FIELDS}
    }
  }
`;

export const DELETE_GATEWAY_SKU = `
  mutation DeleteGatewaySku($uuid: ID!) {
    deleteGatewaySku(uuid: $uuid)
  }
`;

const GATEWAY_ROUTE_MUTATION_FIELDS = `
  uuid
  name
  status
  basePath
  upstreamServer
  upstreamPath
  envName
  gatewayId
  gatewayAuthMechanism
  upstreamAuthMechanism
  purpose
  dataSensitivity
`;

export const CREATE_GATEWAY_ROUTE = `
  mutation CreateGatewayRoute($input: CreateGatewayRouteInput!) {
    createGatewayRoute(input: $input) {
      ${GATEWAY_ROUTE_MUTATION_FIELDS}
    }
  }
`;

export const UPDATE_GATEWAY_ROUTE = `
  mutation UpdateGatewayRoute($uuid: ID!, $input: UpdateGatewayRouteInput!) {
    updateGatewayRoute(uuid: $uuid, input: $input) {
      ${GATEWAY_ROUTE_MUTATION_FIELDS}
    }
  }
`;

export const DELETE_GATEWAY_ROUTE = `
  mutation DeleteGatewayRoute($uuid: ID!) {
    deleteGatewayRoute(uuid: $uuid)
  }
`;

export const ATTACH_GATEWAY_SKU_TO_PRODUCT = `
  mutation AttachGatewaySkuToProduct($productUuid: ID!, $gatewaySkuUuid: ID!, $attachmentName: String) {
    attachGatewaySkuToProduct(
      productUuid: $productUuid
      gatewaySkuUuid: $gatewaySkuUuid
      attachmentName: $attachmentName
    ) {
      uuid
      attachmentName
      gatewaySku {
        uuid
        gatewayCommonName
        gatewayId
        envName
        skuStatus
      }
    }
  }
`;

export const DETACH_GATEWAY_SKU_FROM_PRODUCT = `
  mutation DetachGatewaySkuFromProduct($productUuid: ID!, $gatewaySkuUuid: ID!) {
    detachGatewaySkuFromProduct(productUuid: $productUuid, gatewaySkuUuid: $gatewaySkuUuid)
  }
`;

export const UPDATE_PRODUCT_GATEWAY_SKU_ATTACHMENT = `
  mutation UpdateProductGatewaySkuAttachment($attachmentUuid: ID!, $attachmentName: String) {
    updateProductGatewaySkuAttachment(
      attachmentUuid: $attachmentUuid
      attachmentName: $attachmentName
    ) {
      uuid
      attachmentName
      gatewaySku {
        uuid
        gatewayCommonName
        gatewayId
        envName
        skuStatus
      }
    }
  }
`;

const SUPPORT_CASE_MUTATION_FIELDS = `
  uuid
  tenantId
  name
  description
  createdBy
  createdOn
  caseStatus
  assigneeEmail
  assigneeType
  resolvedAt
  closedAt
  product { uuid name }
`;

export const CREATE_SUPPORT_CASE = `
  mutation CreateSupportCase($input: CreateSupportCaseInput!) {
    createSupportCase(input: $input) {
      ${SUPPORT_CASE_MUTATION_FIELDS}
    }
  }
`;

export const CLAIM_SUPPORT_CASE = `
  mutation ClaimSupportCase($uuid: ID!) {
    claimSupportCase(uuid: $uuid) {
      ${SUPPORT_CASE_MUTATION_FIELDS}
    }
  }
`;

export const ASSIGN_SUPPORT_CASE = `
  mutation AssignSupportCase($uuid: ID!, $assigneeEmail: String!) {
    assignSupportCase(uuid: $uuid, assigneeEmail: $assigneeEmail) {
      ${SUPPORT_CASE_MUTATION_FIELDS}
    }
  }
`;

export const TRANSITION_SUPPORT_CASE_STATUS = `
  mutation TransitionSupportCaseStatus($uuid: ID!, $status: SupportCaseStatus!) {
    transitionSupportCaseStatus(uuid: $uuid, status: $status) {
      ${SUPPORT_CASE_MUTATION_FIELDS}
    }
  }
`;

export const ADD_SUPPORT_CASE_COMMENT = `
  mutation AddSupportCaseComment($uuid: ID!, $body: String!, $commentType: SupportCaseCommentType!) {
    addSupportCaseComment(uuid: $uuid, body: $body, commentType: $commentType) {
      uuid
      authorEmail
      body
      commentType
      createdOn
    }
  }
`;

export const ACCEPT_SUPPORT_CASE_RESOLUTION = `
  mutation AcceptSupportCaseResolution($uuid: ID!) {
    acceptSupportCaseResolution(uuid: $uuid) {
      ${SUPPORT_CASE_MUTATION_FIELDS}
    }
  }
`;

export const UPDATE_TENANT_SUPPORT_CASE_SETTINGS = `
  mutation UpdateTenantSupportCaseSettings($autoCloseResolvedDays: Int!) {
    updateTenantSupportCaseSettings(autoCloseResolvedDays: $autoCloseResolvedDays) {
      tenantId
      autoCloseResolvedDays
      updatedBy
      updatedOn
    }
  }
`;

export const UPDATE_TENANT_ORGANIZATION_SETTINGS = `
  mutation UpdateTenantOrganizationSettings($input: UpdateTenantOrganizationSettingsInput!) {
    updateTenantOrganizationSettings(input: $input) {
      tenantId
      companyName
      address
      website
      phone
      contactEmail
      updatedBy
      updatedOn
    }
  }
`;

export const ADD_TENANT_MEMBER = `
  mutation AddTenantMember($input: AddTenantMemberInput!) {
    addTenantMember(input: $input) {
      tenantId
      email
      displayName
      status
      roles
      createdBy
      createdOn
      updatedOn
    }
  }
`;

export const UPDATE_TENANT_MEMBER = `
  mutation UpdateTenantMember($input: UpdateTenantMemberInput!) {
    updateTenantMember(input: $input) {
      tenantId
      email
      displayName
      status
      roles
      createdBy
      createdOn
      updatedOn
    }
  }
`;

export const REMOVE_TENANT_MEMBER = `
  mutation RemoveTenantMember($email: String!) {
    removeTenantMember(email: $email) {
      tenantId
      email
      status
      roles
    }
  }
`;

export const PURGE_TENANT_DATA = `
  mutation PurgeTenantData($confirmation: String!) {
    purgeTenantData(confirmation: $confirmation) {
      tenantId
      removedMembers
      message
    }
  }
`;

export const CREATE_PLATFORM_TENANT = `
  mutation CreatePlatformTenant($input: CreatePlatformTenantInput!) {
    createPlatformTenant(input: $input) {
      tenantId
      displayName
      status
      createdBy
      createdOn
      updatedOn
    }
  }
`;

export const SET_PLATFORM_TENANT_STATUS = `
  mutation SetPlatformTenantStatus($tenantId: String!, $enabled: Boolean!) {
    setPlatformTenantStatus(tenantId: $tenantId, enabled: $enabled) {
      tenantId
      displayName
      status
      createdBy
      createdOn
      updatedOn
    }
  }
`;

export const UPDATE_PLATFORM_TENANT_ORGANIZATION_SETTINGS = `
  mutation UpdatePlatformTenantOrganizationSettings(
    $tenantId: String!
    $input: UpdateTenantOrganizationSettingsInput!
  ) {
    updatePlatformTenantOrganizationSettings(tenantId: $tenantId, input: $input) {
      tenantId
      companyName
      address
      website
      phone
      contactEmail
      updatedBy
      updatedOn
    }
  }
`;

export const ADD_PLATFORM_TENANT_ADMIN = `
  mutation AddPlatformTenantAdmin($tenantId: String!, $input: AddPlatformTenantAdminInput!) {
    addPlatformTenantAdmin(tenantId: $tenantId, input: $input) {
      tenantId
      email
      displayName
      status
      roles
      createdBy
      createdOn
      updatedOn
    }
  }
`;

export const UPSERT_PLATFORM_AGENT_RUNNER_BINDING = `
  mutation UpsertPlatformAgentRunnerBinding(
    $tenantId: String
    $agentId: String
    $basePath: String!
  ) {
    upsertPlatformAgentRunnerBinding(
      tenantId: $tenantId
      agentId: $agentId
      basePath: $basePath
    ) {
      uuid
      tenantId
      agentId
      basePath
      updatedBy
      updatedOn
    }
  }
`;

export const DELETE_PLATFORM_AGENT_RUNNER_BINDING = `
  mutation DeletePlatformAgentRunnerBinding($uuid: ID!) {
    deletePlatformAgentRunnerBinding(uuid: $uuid)
  }
`;

const OP_ERROR_FIELDS = `
  uuid name status code httpStatus category message remediation errorStrings
  products { uuid name } apis { uuid name }
`;

export const CREATE_OPERATIONAL_ERROR = `
  mutation CreateOperationalError($input: CreateOperationalErrorInput!) {
    createOperationalError(input: $input) {
      ${OP_ERROR_FIELDS}
    }
  }
`;

export const UPDATE_OPERATIONAL_ERROR = `
  mutation UpdateOperationalError($uuid: ID!, $input: UpdateOperationalErrorInput!) {
    updateOperationalError(uuid: $uuid, input: $input) {
      ${OP_ERROR_FIELDS}
    }
  }
`;

export const DELETE_OPERATIONAL_ERROR = `
  mutation DeleteOperationalError($uuid: ID!) {
    deleteOperationalError(uuid: $uuid)
  }
`;

export const BULK_CREATE_OPERATIONAL_ERRORS = `
  mutation BulkCreateOperationalErrors($inputs: [CreateOperationalErrorInput!]!) {
    bulkCreateOperationalErrors(inputs: $inputs) {
      ${OP_ERROR_FIELDS}
    }
  }
`;

const KAFKA_EVENT_TOPIC_FIELDS = `
  uuid name status environment purpose schemaFormat schemaVersion schemaSubject
  compatibilityLevel dataSensitivity partitionCount replicationFactor
  schemaContent keySchemaFormat keySchemaContent samplePayload notes
  classifications entityClass description
  products { uuid name } apis { uuid name }
`;

export const CREATE_KAFKA_EVENT_TOPIC = `
  mutation CreateKafkaEventTopic($input: CreateKafkaEventTopicInput!) {
    createKafkaEventTopic(input: $input) {
      ${KAFKA_EVENT_TOPIC_FIELDS}
    }
  }
`;

export const UPDATE_KAFKA_EVENT_TOPIC = `
  mutation UpdateKafkaEventTopic($uuid: ID!, $input: UpdateKafkaEventTopicInput!) {
    updateKafkaEventTopic(uuid: $uuid, input: $input) {
      ${KAFKA_EVENT_TOPIC_FIELDS}
    }
  }
`;

export const DELETE_KAFKA_EVENT_TOPIC = `
  mutation DeleteKafkaEventTopic($uuid: ID!) {
    deleteKafkaEventTopic(uuid: $uuid)
  }
`;

const API_INTAKE_FIELDS = `
  uuid tenantId name description createdBy createdOn status tags classifications entityClass
  requirementText relatedDocsMarkdown evaluation coverage coveragePercent recommendedChangePath
  recommendedApi { uuid name version }
  matchedApis {
    coveragePercent
    matchRole
    notes
    api { uuid name version }
  }
`;

export const CREATE_API_INTAKE = `
  mutation CreateApiIntake($input: CreateApiIntakeInput!) {
    createApiIntake(input: $input) {
      ${API_INTAKE_FIELDS}
    }
  }
`;

export const UPDATE_API_INTAKE = `
  mutation UpdateApiIntake($uuid: ID!, $input: UpdateApiIntakeInput!) {
    updateApiIntake(uuid: $uuid, input: $input) {
      ${API_INTAKE_FIELDS}
    }
  }
`;

export const DELETE_API_INTAKE = `
  mutation DeleteApiIntake($uuid: ID!) {
    deleteApiIntake(uuid: $uuid)
  }
`;

const PMG_FIELDS = `
  uuid
  tenantId
  name
  description
  owners
  members
  createdBy
  createdOn
  updatedOn
  assignedAssetCount
`;

export const CREATE_PRODUCT_MANAGEMENT_GROUP = `
  mutation CreateProductManagementGroup($input: CreateProductManagementGroupInput!) {
    createProductManagementGroup(input: $input) {
      ${PMG_FIELDS}
    }
  }
`;

export const UPDATE_PRODUCT_MANAGEMENT_GROUP = `
  mutation UpdateProductManagementGroup($uuid: ID!, $input: UpdateProductManagementGroupInput!) {
    updateProductManagementGroup(uuid: $uuid, input: $input) {
      ${PMG_FIELDS}
    }
  }
`;

export const DELETE_PRODUCT_MANAGEMENT_GROUP = `
  mutation DeleteProductManagementGroup($uuid: ID!) {
    deleteProductManagementGroup(uuid: $uuid)
  }
`;

export const ADD_PMG_OWNER = `
  mutation AddPmgOwner($pmgUuid: ID!, $userEmail: String!) {
    addPmgOwner(pmgUuid: $pmgUuid, userEmail: $userEmail) {
      ${PMG_FIELDS}
    }
  }
`;

export const REMOVE_PMG_OWNER = `
  mutation RemovePmgOwner($pmgUuid: ID!, $userEmail: String!) {
    removePmgOwner(pmgUuid: $pmgUuid, userEmail: $userEmail) {
      ${PMG_FIELDS}
    }
  }
`;

export const ADD_PMG_MEMBER = `
  mutation AddPmgMember($pmgUuid: ID!, $userEmail: String!) {
    addPmgMember(pmgUuid: $pmgUuid, userEmail: $userEmail) {
      ${PMG_FIELDS}
    }
  }
`;

export const REMOVE_PMG_MEMBER = `
  mutation RemovePmgMember($pmgUuid: ID!, $userEmail: String!) {
    removePmgMember(pmgUuid: $pmgUuid, userEmail: $userEmail) {
      ${PMG_FIELDS}
    }
  }
`;

export const ASSIGN_PMG_TO_ENTITY = `
  mutation AssignPmgToEntity($input: AssignPmgToEntityInput!) {
    assignPmgToEntity(input: $input)
  }
`;

export const UNASSIGN_PMG_FROM_ENTITY = `
  mutation UnassignPmgFromEntity($pmgUuid: ID!, $entityUuid: ID!) {
    unassignPmgFromEntity(pmgUuid: $pmgUuid, entityUuid: $entityUuid)
  }
`;

export const BULK_ASSIGN_PMG_TO_ENTITIES = `
  mutation BulkAssignPmgToEntities($pmgUuid: ID!, $items: [BulkAssignPmgItemInput!]!) {
    bulkAssignPmgToEntities(pmgUuid: $pmgUuid, items: $items)
  }
`;
